// abConfig.js
export const AB_TESTS = {
    experiment1: {
        id: 'exp1',
        variants: {
            A: { name: 'Variant A', value: 'A' },
            B: { name: 'Variant B', value: 'B' },
        },
    },
};